module.exports = __webpack_public_path__ + "static/hero-left-88a20708cea4e7de1c7ee047966e2d6d.png";